<template>
  <span>
    <span v-if="hasChild">
      <SecondLayerWithChild :width="width" :title="title" :childs="childs" :indexParent="indexParent" />
      <template v-if="width > 1147">
        <li v-show="_index < total">
          <hr v-if="countChildRight!==0" class="dropdown-divider m-0" style="border: 1px #ffffff solid" />
        </li>
      </template>
      <template v-else>
        <li v-if="left? _index <= total: _index < total">
          <hr v-if="countChildRight!==0" class="dropdown-divider m-0" style="border: 1px #ffffff solid" />
        </li>
      </template>
    </span>
    <span v-else>
      <SecondLayerNoChild :width="width" :title="title" :isTheUrl="isUrl(isTrueUrl)" :href="href" :indexParent="indexParent"/>
      <template v-if="width > 1147">
        <!-- <li v-show="_index < total || countChildLeft !== countChildRight"> -->
        <li v-show="_index < total">
          <hr v-if="countChildRight!==0" class="dropdown-divider m-0" style="border: 1px #ffffff solid" />
        </li>
      </template>
      <template v-else>
        <li v-if="left ? _index <= total: _index < total">
          <hr v-if="countChildRight!==0" class="dropdown-divider m-0" style="border: 1px #ffffff solid" />
        </li>
      </template>
    </span>
  </span>
</template>

<script>
import SecondLayerNoChild from "@/Components/Menu/SecondLayerNoChild";
import SecondLayerWithChild from "@/Components/Menu/SecondLayerWithChild";
export default {
  components: {
    SecondLayerNoChild,
    SecondLayerWithChild,
  },
  props: {
    title: String,
    isTheUrl: Boolean,
    href: String,
    hasChild: Boolean,
    childs: Array,
    level:Number,
    total: Number,
    left: Boolean,
    countChildRight: Number,
    countChildLeft: Number,
    _index: Number,
    width: Number,
    indexParent: Number,
  },
  data(){
    return{
    }
  },
  computed: {
    isTrueUrl(){
      if(this.href.startsWith('/id') || this.href.startsWith('/en')) {
        return this.href.substring(3);
      }

      if(this.href.startsWith('en') || this.href.startsWith('en')) {
        return this.href.substring(2);
      }

      return this.href;
    }
  },
};
</script>

<style>
</style>
